import moment from "moment";
import React, { Component } from "react"
import { Datos_Empresa, development } from "../../../libs/utils/Const";

const formatNumber = (num = "") => {
    const separador = ","; // separador para los miles
    const sepDecimal = "."; // separador para los decimales

    let splitStr = num.split(".");
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : "";
    let regex = /(\d+)(\d{3})/;

    while (regex.test(splitLeft)) { splitLeft = splitLeft.replace(regex, "$1" + separador + "$2"); }
    return splitLeft + splitRight;
};

const formatStatus = (status = "") => {
    switch (status) {
        case "P": return "Planificado";
        case "R": return "Liberado";
        default: return "";
    }
}
const formatType = (type = "") => {
    switch (type) { //D=Disassembly, P=Special, S=Standard
        case "D": return "Desmontaje";
        case "P": return "Especial";
        case "S": return "Estándar";
        default: return "";
    }
}

const finalDocStyles = {
    fontSize: { fontSize: 12 },

    colNormal: { whiteSpace: "wrap" },
    colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
}

const previewStyles = {
    fontSize: { fontSize: 13 },
    colNormal: { whiteSpace: "wrap", overflow: "hidden", textOverflow: "ellipsis" },
    colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
}

class ProdOpenDocsReport extends Component {
    render() {
        const { DocsToPrint, ReportsModel, finalDoc } = this.props;
        const styles = finalDoc ? finalDocStyles : previewStyles;

        const Documents = DocsToPrint[0].Docs;

        return (
            <div className="p-4">
                <div className="row text-center">
                    <div className="col-3 align-content-center" style={styles.fontSize}>
                        <img src={development ? require("../../../images/logo_draft.svg") : require("../../../images/logo_EMPRESA.svg")} alt="Logo" />
                        {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}
                    </div>
                    <div className="col-5 align-content-center">
                        <p className="font-weight-bold h5"> Producción - Partidas Abiertas </p>
                    </div>
                    <div className="col-4 text-right">
                        <p> {ReportsModel?.user?.Branch?.Address || `${Datos_Empresa.Calle} No. ${Datos_Empresa.Numero}, COL. ${Datos_Empresa.Colonia}, ${Datos_Empresa.Ciudad}, ${Datos_Empresa.Estado}. ${Datos_Empresa.Pais}`} al {moment().format("DD/MM/YYYY")}</p>
                        {ReportsModel.user && <p> Impreso por: {ReportsModel.user.USER_CODE} - {ReportsModel.user.U_NAME} </p> }
                    </div>
                </div>

                <div className="mt-4" style={styles.fontSize}>
                    <div className="border border-dark font-weight-bold">
                        <div className="row px-3">
                            <div className="col-3">
                                <div className="row">
                                    <div className="col-4" style={styles.colNormal}> N° Doc </div>
                                    <div className="col-4" style={styles.colNormal}> Serie </div>
                                    <div className="col-4" style={styles.colNormal}> Tipo </div>
                                </div>
                            </div>

                            <div className="col-9">
                                <div className="row">
                                    <div className="col-1" style={styles.colNormal}> Estatus </div>
                                    <div className="col-2" style={styles.colNormal}> Artículo </div>
                                    <div className="col-2" style={styles.colNormal}> Descripción </div>
                                    <div className="col-1 p-0" style={styles.colNumber}> Cantidad </div>
                                    <div className="col-2" style={styles.colNormal}> Fecha </div>
                                    <div className="col-2" style={styles.colNormal}> F. Inicio </div>
                                    <div className="col-2" style={styles.colNormal}> F. Vencimiento </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="border border-dark">
                        {Documents.map((Document, index) =>
                            <div className="row px-3">
                                <div className={`col-3 ${index ? "border-top" : ""} border-dark py-2`}>
                                    <div className="row">
                                        <div className="col-4" style={styles.colNormal}> {Document.DocNum} </div>
                                        <div className="col-4" style={styles.colNormal}> {Document.SeriesName} </div>
                                        <div className="col-4" style={styles.colNormal}> {formatType(Document.Type)} </div>
                                    </div>
                                </div>
                                <div className={`col-9 ${index ? "border-top" : ""} border-dark py-2`}>
                                    <div className="row">
                                        <div className="col-1" style={styles.colNormal}> {formatStatus(Document.Status)} </div>
                                        <div className="col-2" style={styles.colNormal}> {Document.ItemCode} </div>
                                        <div className="col-2" style={styles.colNormal}> {Document.ItemName} </div>
                                        <div className="col-1 p-0" style={styles.colNumber}> {formatNumber(Number(Document.PlannedQty).toFixed(3))} </div>
                                        <div className="col-2" style={styles.colNormal}> {moment(Document.PostDate).format("DD/MM/YYYY")} </div>
                                        <div className="col-2" style={styles.colNormal}> {moment(Document.StartDate).format("DD/MM/YYYY")} </div>
                                        <div className="col-2" style={styles.colNormal}> {moment(Document.DueDate).format("DD/MM/YYYY")} </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default ProdOpenDocsReport